import api, { useApi } from '@utils/api'
import { API_ENDPOINTS } from '@utils/api-endpoints'
import { Location, LocationData } from '@framework/model-types/Location'

const getShopLocations = async (shopId: string) => {
  try {
    const { data } = await api.get(API_ENDPOINTS.GET_SHOP_LOCATIONS(shopId))

    return { locations: { ...data } }
  } catch (error) {
    const data = {
      data: [],
      msg: 'Locations not found',
      success: false,
    }
    return { locations: { ...data } }
  }
}

const useSWRGetShopLocations = (
  shopId: string,
  filter?: string,
): {
  locations: LocationData | Location[] | undefined
  isLoading: boolean
  isError: boolean
  mutate: ReturnType<typeof useApi>['mutate']
  key: ReturnType<typeof useApi>['key']
} => {
  let url = `${API_ENDPOINTS.GET_SHOP_LOCATIONS(shopId)}`
  filter && (url += `?${filter}`)
  const { data, isError, mutate, isLoading } = useApi(url)
  return {
    locations: data?.data,
    isLoading,
    isError,
    mutate,
    key: url,
  }
}

// const deleteShopLocation = async (shopId: string, locationId : string) => {
//     try {
//         const url = `${API_ENDPOINTS.MANAGE_SHOP_LOCATION(shopId, locationId)}/${locationId}`
//         const { data } = await api.delete(url);
//         return { location: { ...data } };
//     } catch (error) {
//         const data = {
//             data: null,
//             msg: "Delete location failed",
//             success: false
//         }
//         return { location: { ...data } };
//     }
// };

export {
  getShopLocations,
  useSWRGetShopLocations,
  // deleteShopLocation,
}
